import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatErr } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, object=auth
  const [error, setError] = useState("");

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      localStorage.removeItem("token");
      setUser(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  async function login(username, password) {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { username, password });
      if (data.token) localStorage.setItem("token", data.token);
      await fetchMe();
      return true;
    } catch (e) {
      setError(formatErr(e.response?.data?.detail) || e.message);
      return false;
    }
  }

  function logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("audit_tenant_id");
    setUser(false);
    // Fire-and-forget the API call so the UI redirects instantly
    api.post("/auth/logout").catch(() => {});
    window.location.assign("/");
  }

  async function enterAudit(tenantId) {
    await api.post(`/admin/tenants/${tenantId}/audit`);
    await fetchMe();
  }

  async function exitAudit() {
    await api.post("/admin/audit/exit");
    await fetchMe();
  }

  return (
    <AuthContext.Provider value={{ user, error, login, logout, fetchMe, enterAudit, exitAudit }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
